<template>
  <div class="w-100 login-wrapper">
    <div class="login-container">
      <div class="login-wrapper-image">
        <a href="/app" class="tablet-hidden">
          <img alt="logo" src="./../assets/img/logo-new.svg" class="login-logo mb-2">
        </a>
        <div class="registration-greetings" v-if="showRegistration">
          <img alt="logo" src="./../assets/img/logo-new.svg" class="logo mb-1 mobile-hidden">
          <div class="congratulations-title">
            {{ $lang.messages.registration.congratulations }}
            <div class="registration-greetings-animation"><img class="" src="../assets/img/Comp-1.gif" alt="comp"></div>
          </div>
          <div class="congratulations-subtitle">
            {{ $lang.messages.registration.on_creating }}
            <div class="header-login flex-v-center account-settings-block">
              <span class="header-text account-settings">
                <span class="account-settings-avatar"></span>
                {{ $lang.messages.registration.parent_account }}
              </span>
            </div>
          </div>
          <div class="congratulations-arrow">
            {{ $lang.messages.registration.step_left }} <span class="arrow-span"></span>
          </div>
        </div>
        <img src="../assets/img/login-image.png" alt="login" v-else class="mobile-hidden">
      </div>
      <div class="login-popup" v-show="!showRegistration">
        <a href="/app" class="mobile-hidden">
          <img alt="logo" src="./../assets/img/logo-new.svg" class="logo mb-2">
        </a>
        <div>
          <div class="content-block-title">{{ $lang.messages.registration.parent_account }}</div>
          <p class="mb-2 content-block-description">{{ $lang.messages.registration.access_to_your }} <strong>{{ $lang.messages.registration.free }}</strong>
            {{ $lang.messages.registration.parent_account_control_kids }}
          </p>
          <div v-show="!user.uid && !showLoginFormLoader" id="firebaseui-auth-container" ref="fbFrom"></div>
          <Loader v-if="showLoginFormLoader" />
        </div>
      </div>
      <div v-show="showRegistration" class="kid-configuration-dialog">
        <div class="kid-configuration-dialog-logo">
          <img :src="require('../assets/img/kid-profile.svg')" alt="avatar">
        </div>
        <h2 class="text-center mt-0">{{ $lang.messages.add_profile.create_kid_profile }}</h2>
        <form action="#" @submit.prevent autocomplete="off">
            <div class="form-group">
              <label for="kidName" class="form-label">{{ $lang.messages.add_profile.kid_name }}</label>
              <input v-model="kidName" maxlength="15" id="kidName" type="text" class="form-control" :placeholder="$lang.messages.add_profile.enter_name" autocomplete="off">
              <div v-if="nameError" class="form-error">{{ $lang.messages.add_profile.name_error }}</div>
            </div>
            <div class="form-group">
              <div class="flex-between w-100">
                <label for="passcode" class="form-label">{{ $lang.messages.passcode }}</label>
                <span class="form-label">{{ $lang.messages.app.passcode.digits }}</span>
              </div>
              <InputPassword passwordVisible="true" maxLength="4" @changepassword="accountPassword = $event" id="passcode" :value="accountPassword"  />
              <div v-if="passwordError" class="form-error">{{ $lang.messages.app.passcode.passcode_error }}</div>
            </div>
            <div class="text-center text-secondary mb-1">
              {{ $lang.messages.app.passcode.description }}
            </div>
            <div class="text-center">
              <button class="btn btn-main" @click="savePasscode">{{ $lang.messages.add_profile.create_profile }}</button>
            </div>
          </form>
      </div>
    </div>
    <WelcomeScreens alias="installWelcome" v-if="showWelcome" @hidewelcome="showWelcome = false"/>
  </div>
</template>

<script>
import firebase from "firebase/app";

import * as firebaseui from "firebaseui";
import 'firebaseui/dist/firebaseui.css'
import {reportEvent, sendRegistrationEmail, getCookie} from "@/helpers/utils";
import {createActiveCampaignContact} from "@/helpers/api";
import {mapState} from "vuex";
import saveSetting from "@/components/mixins/saveSetting";
import InputPassword from "@/components/InputPassword";
import Loader from "@/components/Loader";
import WelcomeScreens from "@/components/WelcomeScreens";

export default {
  name: 'Login',
  mixins: [saveSetting],
  components: {WelcomeScreens, InputPassword, Loader},
  data: function () {
    return {
      userEmail: null,
      showRegistration: false,
      showPremiumIsPurchased: false,
      accountPassword: '1111',
      kidName: 'Kid 1',
      nameError: false,
      passwordError: false,
      isAndroid: window.Android,
      showWelcome: this.$route.query.showWelcome,
      observer: null,
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      accountData: state => state.accountData,
      isRemote: state => state.isRemote,
      showLoginFormLoader: state => state.showLoginFormLoader,
    }),
  },
  watch: {
    $route() {
      this.showRegistration = this.$router.currentRoute.query.register
    }
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  mounted () {
    this.$store.commit('setFbUiShowing', true);
    if (this.showWelcome) {
        if (window.gtag) {
            window.gtag('event', 'conversion', {'send_to': 'AW-441971167/9FwvCOSYt5sDEN_j39IB'});
        }
    }

    if (this.user.uid){
      if (this.accountData.isRegistered) {
        if (this.isAndroid) {
          this.$router.push('/popup');
        } else {
          this.$router.push('/freeDashboard');
        }
      } else {
        this.showRegistration = true;
      }
    } else {
      const $this = this;
      const ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth());
      ui.start('#firebaseui-auth-container', {
        signInOptions: [
          {
            provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
            requireDisplayName: true,
          }
        ],
        callbacks: {
          // eslint-disable-next-line no-unused-vars
          signInSuccessWithAuthResult(authResult, redirectUrl) {
            if (authResult.additionalUserInfo.isNewUser) {
              $this.showRegistration = true;
              reportEvent('showAdditionalCredentialsDialog');
              const tags = [
                  $this.isAndroid ? 'registeredFromAndroid' : 'registeredFromDesktop',
                  getCookie('logmixpanel_source') ? getCookie('logmixpanel_source') : 'organic'
              ];

              sendRegistrationEmail(authResult.user.email);
              createActiveCampaignContact({
                email: authResult.user.email,
                first_name: authResult.user.displayName,
                tags: tags.join(','),
              }).then(res => {
                console.log(res);
              });
              reportEvent('createAccount', {'email': authResult.user.email, 'firebaseUserId': authResult.user.uid});
              if (window.gtag) {
                  window.gtag('event', 'conversion', {'send_to': 'AW-441971167/SPdFCIOttZsDEN_j39IB'});
              }
            } else {
              sessionStorage.setItem('unlocked', '1');
              reportEvent('userSignIn', {
                'firebaseUserId': authResult.user.uid,
                'isAnonymous': false,
                'email': authResult.user.email,
                platform: $this.isAndroid ? 'android' : 'extension',
              });
            }
            return false;
          },
          signInFailure(error) {
            console.log(error);
          },
          uiShown: function() {
            // todo check for better solution
            $this.$store.commit('setFbUiShowing', false)
            document.querySelector('.firebaseui-title').innerHTML = "Enter parent's email";
          }
        },
      });

      this.observer = new MutationObserver(function (mutationsList) {
        for (let mutation of mutationsList) {
          if (mutation.addedNodes[0] && mutation.addedNodes[0].querySelector('#ui-sign-in-password-input')) {
            reportEvent('showLoginForm');
          } else if (mutation.addedNodes[0] && mutation.addedNodes[0].querySelector('#ui-sign-in-new-password-input')) {
            reportEvent('showRegistrationForm')
          }
        }
      });
      this.observer.observe(this.$refs.fbFrom, {childList: true});
    }
  },

  methods: {
    savePasscode() {
      this.passwordError = false
      this.nameError = false
      if(!/^[0-9]+$/.test(this.accountPassword) || this.accountPassword.length !== 4){
        this.passwordError = true
      } else if(this.kidName.trim() === ''){
        this.nameError = true
      } else {
        this.saveAccountSettings(
            {
              password: this.accountPassword,
              isRegistered: true,
            }
        ).then(() => {
         return this.saveProfileSettings('defaultProfileSettings', {kidName: this.kidName})
        }).then(() => {
          if (this.isAndroid) {
            window.Android.onRegistrationEnd();
          } else {
            if (this.isRemote && this.$route.path !== '/addDevice') {
              const queryPremium = this.$route.query.openPremiumModal ? '?openPremiumModal=1' : '';
              let queryPlan = '';
              if(queryPremium !== ''){
                queryPlan = this.$route.query.plan === 'month' ? '&plan=month' : '&plan=year';
              }
              const queryAll = queryPremium + queryPlan
              this.$router.push('/premium' + queryAll);
            } else {
              sessionStorage.setItem('unlocked', '1');
              this.$router.push('/freeDashboard');
            }
          }
        })
      }
    },
    out() {
      firebase.auth().signOut();
      reportEvent('userSignOut');
    },
  },
}
</script>

<style lang="scss">
@import "../assets/styles/helpers";
@import "../assets/styles/themes";
@import "../assets/styles/kid";

.login{
  &-wrapper {
    padding: 50px;
    background: linear-gradient(331.33deg, #CFD1F4 11.55%, #EFF1FF 51.74%), #F5F7FB;
    height: 100%;
    display: flex;
    align-items: center;

    @include responsive-below($sm){
      padding: 0;
      display: block;
    }

    &-image {
      display: flex;
      align-items: center;
      flex: 0 0 50%;

      @include responsive-below($sm){
        display: block;
        text-align: center;
        padding: 0 20px;
        margin-bottom: 20px;
      }
    }
  }

  &-container {
    width: 1080px;
    max-width: 100%;
    padding: 0 20px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    @include responsive-below($sm){
      display: block;
      padding: 20px 0;
    }

    .content-block-title {
      margin-bottom: 12px;
    }
  }
}

.login-popup {
  width: 360px;
  margin-left: auto;

  @include responsive-below($sm){
    margin: 0 auto;
    max-width: 100%;
    padding: 0 20px;
  }

  .logo {
    width: 109px;
  }

  .content-block-description {
    color: #848484;
    font-size: 16px;
    line-height: 21px;
    
    strong {
      color: #7d6aed;
    }
  }
}

.kid-configuration-dialog {
  background: #FFFFFF;
  box-shadow: 0px 100px 80px rgba(0, 0, 0, 0.07), 0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0503198), 0px 22.3363px 17.869px rgba(0, 0, 0, 0.0417275);
  border-radius: 16px;
  position: relative;
  width: 486px;
  padding: 70px 50px 36px;

  @include responsive-below($sm) {
    margin: 60px auto 0;
    max-width: 90%;
    padding: 50px 30px 26px;
  }

  &-logo {
    position: absolute;
    left: 50%;
    top: -45px;
    transform: translateX(-50%);
    width: 90px;
    height: 90px;
    border-radius: 50%;
    overflow: hidden;
  }
}

.registration-greetings {
  .registration-greetings-animation {
    display: inline-block;
    width: 39px;
    height: 39px;
    position: relative;
    vertical-align: middle;

    img {
      position: absolute;
      max-width: none;
      top: -39px;
      left: -15px;
    }
  }

  .logo {
    width: 170px;
  }

  .congratulations-title {
    font-weight: bold;
    font-size: 30px;
    line-height: 39px;
    text-transform: uppercase;
    margin-bottom: 10px;

    @include responsive-below($sm) {
      font-size: 24px;
    }
  }

  .congratulations-subtitle,
  .congratulations-arrow {
    font-size: 24px;
    font-weight: bold;
    line-height: 31px;
  }

  .congratulations-subtitle {
    margin-bottom: 80px;
    display: flex;
    align-items: center;

    @include responsive-below($sm) {
      margin-bottom: 20px;
      justify-content: center;
    }

    .account-settings {
      padding: 4px 17px 4px 4px;
      border-radius: 60px;
      background-color: #C8CEFB;
      font-weight: normal;

      .account-settings-avatar{
        width: 26px;
        height: 26px;
        border: 2px solid #E3E5EF;
        box-sizing: border-box;

        &:before {
          width: 22px;
          height: 22px;
          left: 0;
          top: 0;
        }
      }
    }
  }

  .congratulations-arrow {
    display: flex;
    align-items: center;

    @include responsive-below($sm) {
      justify-content: center;
    }
  }

  .arrow-span {
    display: inline-block;
    margin-left: 20px;
    width: 208px;
    height: 3px;
    position: relative;
    background: #5253DB;;

    @include responsive-below($sm) {
      display: none;
    }

    &:after {
      content: '';
      position: absolute;
      border-top: 3px solid #5253DB;
      border-right: 3px solid #5253DB;
      width: 20px;
      height: 20px;
      transform: rotateZ(45deg);
      right: 1px;
      top: -10px;
    }
  }
}

.login-logo {
  max-width: 130px;
}

.firebaseui-container {
  font-family: 'Nunito';
}

.firebaseui-title {
  font-weight: 700;
}
</style>
